import moment from 'moment';
import { updateObject } from "../../storeFunctions";
import { _name, LOAD_TYPE } from '../common/constants';
import { _eventLoggerSend, _unique } from '../common/functions';
import { _checkLoadConditions, _load, _raiseDataChanged } from '../diagram/actions';
import { diagram } from '../diagram/initial';

// KEYS
const actions = {
    LEFT_PANEL: { _name: _name + '_LEFT_PANEL' },
};
actions.LEFT_PANEL = Object.assign(actions.LEFT_PANEL, {
    TOGGLE: actions.LEFT_PANEL._name + '_TOGGLE'
});

// MAP
const actionMap = {
    [`${actions.LEFT_PANEL.TOGGLE}`]: (state, data) => updateObject(state, { leftPanel: updateObject(state.leftPanel, data), topPanel: updateObject(state.topPanel, { exportUsed: [] }) }),
}

// ACTIONS
const chartActions = {
    toggleLeftPanel: (expanded) => async (dispatch, getState) => {
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { expanded } });
        diagram.diagram.nodeDiagram.requestUpdate();
    },
    // level
    changeLevel: (level = 1, mode = 2) => async (dispatch, getState) => {
        if (mode !== 2) {
            _checkLoadConditions(
                getState,
                () => {
                    _changeLevel(dispatch, level);
                    _load(dispatch, getState, LOAD_TYPE.common);
                }
            );
        }
    },
    // lock
    lockAll: (lockAll) => async (dispatch) => _lockAll(lockAll, dispatch),
    // apply
    applyFilter: () => async (dispatch, getState) => {
        _checkLoadConditions(
            getState,
            () => _load(dispatch, getState, LOAD_TYPE.common)
        );
    },
    // historicalRelations
    changeHistory: (value) => async (dispatch) => {
        diagram.diagramParams.history = value;
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { history: value, historyChanged: true, filterChanged: true } });
        _disableHistoricalRelations(value);
    },
    histDateChange: (idx, day) => async (dispatch) => {
        const date = moment(day, "DD.MM.YYYY", true).isValid() ? moment(day, "DD.MM.YYYY").toDate() : null;
        if (idx === 0) {
            diagram.diagramParams.dateFrom = date;
            dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { dateFrom: date, historyChanged: true, filterChanged: true } });
        }
        else if (idx === 1) {
            diagram.diagramParams.dateTo = date;
            dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { dateTo: date, historyChanged: true, filterChanged: true } });
        }
    },
    // relationDirections
    changeDirection: (val) => async (dispatch, getState) => {
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { filterChanged: true, directionChanged: true, linkDirection: val } });
        diagram.diagramParams.direction = val;
        _changeLinkDirection(val);
    },
    // ownershipInterest
    changeShare: (shareValue, shareChecked) => async (dispatch, getState) => {
        if (typeof shareValue === "string")
            shareValue = shareValue.replace("%", "");
        shareValue = parseInt(shareValue);
        if (shareValue === null || isNaN(shareValue))
            shareValue = 50;
        if (shareValue > 100)
            shareValue = 100;
        if (shareValue < 0)
            shareValue = 0;
        diagram.diagramParams.sharePct = shareValue;
        diagram.diagramParams.shareChecked = shareChecked;
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { shareChecked, shareChanged: true, filterChanged: true, shareValue } });
        _changeShare(shareValue, shareChecked);
    },
    // relationTypes
    changeRelationTypes: (all) => async (dispatch, getState) => {
        diagram.diagramParams.rt = all.map(function (a) { return a.value; });
        var allChecked = _allRelationTypesChecked(getState);
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { filterChanged: true, rt: diagram.diagramParams.rt, relationTypesChanged: true, relTypesAllChecked: allChecked.checked, relTypesAllPartial: allChecked.partial } });
        _changeRelationTypes();
    },
    addRelType: (id) => async (dispatch, getState) => {
        var relType = getState().charts.domains.relationTypes.filter(function (f) { return f.value === id });
        var relTypes = _findRelChilds(relType[0])
        diagram.diagramParams.rt = _unique(diagram.diagramParams.rt.concat(relTypes));
        var allChecked = _allRelationTypesChecked(getState);
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { filterChanged: true, rt: diagram.diagramParams.rt, relationTypesChanged: true, relTypesAllChecked: allChecked.checked, relTypesAllPartial: allChecked.partial } });
        _changeRelationTypes();
    },
    removeRelType: (id) => async (dispatch, getState) => {
        diagram.diagramParams.rt = diagram.diagramParams.rt.filter(function (f) { return !f.startsWith(id) });
        var allChecked = _allRelationTypesChecked(getState);
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { filterChanged: true, rt: diagram.diagramParams.rt, relationTypesChanged: true, relTypesAllChecked: allChecked.checked, relTypesAllPartial: allChecked.partial } });
        _changeRelationTypes();
    },
    allRelTypes: (isAll) => async (dispatch, getState) => {
        diagram.diagramParams.rt = [];
        if (isAll) {
            var relType = getState().charts.domains.relationTypes;
            for (var i = 0; i < relType.length; i++)
                diagram.diagramParams.rt = diagram.diagramParams.rt.concat(_findRelChilds(relType[i]));
        }
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { filterChanged: true, rt: diagram.diagramParams.rt, relationTypesChanged: true, relTypesAllChecked: isAll, relTypesAllPartial: false } });
        _changeRelationTypes();
    },
    // warningTypes
    changeWarningTypes: (all) => async (dispatch, getState) => {
        diagram.diagramParams.wt = all.map(function (a) { return a.value; });
        var allChecked = _allWarningTypesChecked(getState);
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { wt: diagram.diagramParams.wt, warTypesAllChecked: allChecked.checked, warTypesAllPartial: allChecked.partial } });
        _applyWarningTypeFilter();
    },
    addWarType: (id) => async (dispatch, getState) => {
        var warType = getState().charts.domains.warningTypes.filter(function (f) { return f.value === id });
        var warTypes = _findRelChilds(warType[0])
        diagram.diagramParams.wt = _unique(diagram.diagramParams.wt.concat(warTypes));
        var allChecked = _allWarningTypesChecked(getState);
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { wt: diagram.diagramParams.wt, warTypesAllChecked: allChecked.checked, warTypesAllPartial: allChecked.partial } });
        _applyWarningTypeFilter();
    },
    removeWarType: (id) => async (dispatch, getState) => {
        diagram.diagramParams.wt = diagram.diagramParams.wt.filter(function (f) { return !f.startsWith(id) });
        var allChecked = _allWarningTypesChecked(getState);
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { wt: diagram.diagramParams.wt, warTypesAllChecked: allChecked.checked, warTypesAllPartial: allChecked.partial } });
        _applyWarningTypeFilter();
    },
    allWarTypes: (isAll) => async (dispatch, getState) => {
        diagram.diagramParams.wt = [];
        if (isAll) {
            var warType = getState().charts.domains.warningTypes;
            for (var i = 0; i < warType.length; i++)
                diagram.diagramParams.wt = diagram.diagramParams.wt.concat(_findRelChilds(warType[i]));
        }
        dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { wt: diagram.diagramParams.wt, warTypesAllChecked: isAll, warTypesAllPartial: false } });
        _applyWarningTypeFilter();
    },
    // other
    applyFloatingFilter: (enabled, year) => async (dispatch, getState) => {
        _applyFloatingFilter(enabled, year);
    },
}

// FUNCTIONS

function _changeLevel(dispatch, lvl) {
    dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { level: lvl } });
    diagram.diagramParams.level = lvl;
    _eventLoggerSend('levelChanged', lvl);
}

function _lockAll(state, dispatch) {
    diagram.nodeDiagram.startTransaction("checkedAllNodes");
    var roots = [];
    diagram.nodeDiagram.findTreeRoots().each(function (root) { roots.push(root); });

    diagram.nodeDiagram.nodes.each(function (node) {
        var nodeIsRoot = roots.filter(r => r.data.EntityID === node.data.EntityID);
        if (nodeIsRoot.length === 0) {
            if (node.data.IsLocked !== state && (!node.data.SystemLock || (!node.data.IsLocked && state))) {
                _raiseDataChanged(node.data, "IsLocked", state);
            }
        }
    });
    dispatch({ type: actions.LEFT_PANEL.TOGGLE, data: { lockedAll: state } });
    diagram.nodeDiagram.commitTransaction("checkedAllNodes");
    _eventLoggerSend(state ? 'lockAll' : 'unlockAll');
}

function _disableHistoricalRelations(value) {

    _eventLoggerSend('histRelations', value === true ? 'on' : 'off');
    if (value === true)
        _enableAllRelations();
    else {
        var enabledLinks = [];
        var disabledLinks = [];
        var it = diagram.nodeDiagram.links.iterator;

        while (it.next()) {
            if (it.value.data.RelationsData.filter(rd => rd.State !== 0).length === 0)
                enabledLinks.push(it.value);
            else disabledLinks.push(it.value);
        };

        var enabledNodes = _unique(enabledLinks.map(p => p.data.ParentID).concat(enabledLinks.map(p => p.data.ChildID)));
        _enableLinks(enabledLinks);
        _disableLinks(disabledLinks, enabledNodes);
    }
}

function _enableAllRelations() {
    var enabledLinks = [];
    var it = diagram.nodeDiagram.links.iterator;
    while (it.next()) {
        enabledLinks.push(it.value);
    };
    _enableLinks(enabledLinks);
}

function _changeLinkDirection(val) {
    var relationDirectionFilter;
    if (val === 0) {
        relationDirectionFilter = [-1, 1, 0];
    } else {
        relationDirectionFilter = [val, 0];
    }
    _eventLoggerSend('relationDirection', relationDirectionFilter.join(','));

    var enabledLinks = [];
    var disabledLinks = [];

    var it = diagram.nodeDiagram.links.iterator;
    while (it.next()) {
        if (relationDirectionFilter.filter(f => f === it.value.data.Polarity).length > 0)
            enabledLinks.push(it.value)
        else
            disabledLinks.push(it.value)
    }

    var enabledNodes = _unique(enabledLinks.map(p => p.data.ParentID).concat(enabledLinks.map(p => p.data.ChildID)));
    _disableLinks(disabledLinks, enabledNodes);
    _enableLinks(enabledLinks);
}

function _changeShare(value, checked) {
    var enabledLinks = [];
    var disabledLinks = [];

    var it = diagram.nodeDiagram.links.iterator;
    while (it.next()) {
        if (it.value.data.SharePct == null || it.value.data.SharePct >= value) enabledLinks.push(it.value);
        else disabledLinks.push(it.value);
    };

    var enabledNodes = _unique(enabledLinks.map(p => p.data.ParentID).concat(enabledLinks.map(p => p.data.ChildID)));
    _enableLinks(enabledLinks);
    _disableLinks(disabledLinks, enabledNodes);

    if (!checked) {
        _enableLinks(disabledLinks);
        _enableLinks(enabledLinks);
    }
}

function _allRelationTypesChecked(getState) {
    var checked = true;
    var allTypes = getState().charts.domains.relationTypes;
    for (var i = 0; i < allTypes.length; i++)
        if (diagram.diagramParams.rt.indexOf(allTypes[i].value) === -1)
            checked = false;
    return { checked, partial: diagram.diagramParams.rt.length > 0 && !checked }
}

function _changeRelationTypes() {
    var enabledLinks = [];
    var disabledLinks = [];

    var it = diagram.nodeDiagram.links.iterator;
    while (it.next()) {
        if (_checkRelTypes(it.value.data.RelationsData))
            enabledLinks.push(it.value);
        else
            disabledLinks.push(it.value);
    };

    var enabledNodes = _unique(enabledLinks.map(p => p.data.ParentID).concat(enabledLinks.map(p => p.data.ChildID)));
    _disableLinks(disabledLinks, enabledNodes);
    _enableLinks(enabledLinks);
}

function _checkRelTypes(linkRelations) {
    for (var i = 0; i < linkRelations.length; i++) {
        if (diagram.diagramParams.rt.indexOf(linkRelations[i].RelationType) !== -1) {
            return true;
        }
    }
    return false;
}

function _enableLinks(links) {
    links.forEach(function (link) {
        _enableElement(link);
        _enableElement(link.toNode);
        _enableElement(link.fromNode);
    });
}

function _disableLinks(links, enabledNodes) {
    var nodes = [];
    links.forEach(function (link) {
        _disableElement(link);
        if (enabledNodes.indexOf(link.toNode.data.EntityID) === -1)
            nodes.push(link.toNode);
    });

    nodes = _unique(nodes);
    nodes.forEach(function (node) {
        if (node.findLinksConnected().each(function (val) { return links.indexOf(val) >= 0; })) {
            _disableElement(node);
        }
    });
}

function _disableElement(element) {
    if (element != null) {
        element.selectable = false;
        element.movable = false;
        element.opacity = 0.3;
    }
}

function _enableElement(element) {
    if (element != null) {
        element.selectable = true;
        element.movable = true;
        element.opacity = 1;
    }
}

function _findRelChilds(relType) {
    var result = [];
    result.push(relType.value);
    for (var i = 0; i < relType.children.length; i++) {
        result = result.concat(_findRelChilds(relType.children[i]));
    }
    return result;
}

function _allWarningTypesChecked(getState) {
    var checked = true;
    var allTypes = getState().charts.domains.warningTypes;
    for (var i = 0; i < allTypes.length; i++)
        if (diagram.diagramParams.wt.indexOf(allTypes[i].value) === -1)
            checked = false;
    return { checked, partial: diagram.diagramParams.wt.length > 0 && !checked }
}

function _applyWarningTypeFilter() {
    var warningsFilter = diagram.diagramParams.wt;

    diagram.nodeDiagram.model.nodeDataArray.forEach(function (node) {
        if (node == null || node === undefined) {
            return;
        }

        if (node.WarningShortcuts != null && node.WarningShortcuts !== undefined) {
            node.WarningShortcuts.forEach(function (warning) {
                const newVal = !(warningsFilter.filter(ww => ww === warning.GroupID).length === 0) || warning.StatusID === '0x' || warning.StatusID === '0y';
                _raiseDataChanged(warning, "IsFiltered", newVal);

            });
        }

        if (node.WarningOverview != null && node.WarningOverview !== undefined) {
            node.WarningOverview.forEach(function (warning) {
                const newVal = !(warningsFilter.filter(ww => ww === warning.GroupID).length === 0) || warning.StatusID === '0x' || warning.StatusID === '0y';
                _raiseDataChanged(warning, "IsFiltered", newVal);
            });
        }
    });
}

function _applyFloatingFilter(enabled, year) {
    if (enabled) {
        var enabledLinks = [];
        var disabledLinks = [];
        var date = new Date(Math.round(year), Math.round((year - Math.round(year)) * 12) - 1, 1);
        var it = diagram.nodeDiagram.links.iterator;
        while (it.next()) {
            if (it.value.data.RelationsData.filter(rd => (rd.StartDate == null || new Date(rd.StartDate) < date) && (rd.EndDate == null || new Date(rd.EndDate) > date)).length !== 0)
                enabledLinks.push(it.value);
            else
                disabledLinks.push(it.value);
        };
        var enabledNodes = _unique(enabledLinks.map(p => p.data.ParentID).concat(enabledLinks.map(p => p.data.ChildID)));

        _enableLinks(enabledLinks);
        _disableLinks(disabledLinks, enabledNodes);
    }
    else
        _enableAllRelations();
}


function getLeftPanelHeight() {
    return getWindowHeight() - ((document.getElementById('statusPanel') || {}).clientHeight || 0) - ((document.getElementById('topSidePanelWrapper') || {}).clientHeight || 0)
}

function getWindowHeight() {
    return window.innerHeight;
}

export {
    _allRelationTypesChecked, _allWarningTypesChecked, _applyWarningTypeFilter, _changeLevel, _findRelChilds, getLeftPanelHeight, _changeRelationTypes,
    actionMap as leftPanelActionMap, actions as leftPanelActions, chartActions as leftPanelChartActions
};
